export default __webpack_public_path__ + "static/media/TopGator3.0af45de6.jpg";